<template>
  <section class="container section-scc-portal">
    <div id="block-contacts">
      <div class="block-address" v-if="contactUsData.contactUsAddress !== ''">
        <div class="container-icon">
          <svg preserveAspectRatio="xMidYMid meet" class="contact-pointer" data-bbox="42 20.5 116 159" viewBox="42 20.5 116 159" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img">
            <g>
              <path d="M99.999 179.5l-4.053-4.877C93.746 171.972 42 109.349 42 78.612 42 46.569 68.018 20.5 99.999 20.5 131.985 20.5 158 46.569 158 78.612c0 30.738-51.743 93.361-53.948 96.011l-4.053 4.877zm0-148.434c-26.166 0-47.455 21.328-47.455 47.545 0 20.481 31.206 63.869 47.455 84.264 16.252-20.394 47.458-63.783 47.458-84.264-.001-26.217-21.289-47.545-47.458-47.545z" fill="#4854C7" data-color="1">
              </path>
              <path d="M99.999 102.075c-12.911 0-23.419-10.525-23.419-23.464s10.507-23.466 23.419-23.466c12.914 0 23.421 10.527 23.421 23.466 0 12.939-10.507 23.464-23.421 23.464zm0-36.364c-7.097 0-12.872 5.786-12.872 12.9 0 7.112 5.775 12.899 12.872 12.899 7.1 0 12.878-5.787 12.878-12.899-.001-7.114-5.779-12.9-12.878-12.9z" fill="#4854C7" data-color="1">
              </path>
            </g>
          </svg>
        </div>
        <p class="text-contact">
          <span>{{ contactUsData.contactUsAddress }}</span>
        </p>
      </div>
      <div class="block-address" v-if="contactUsData.contactUsPhone !== ''">
        <div class="container-icon">
          <svg preserveAspectRatio="xMidYMid meet" class="contact-pointer" data-bbox="23.5 23.5 153 152.999" viewBox="23.5 23.5 153 152.999" height="200" width="200" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img">
            <g>
              <path d="M57.671 34.013c2.802 0 5.998 1.02 8.46 4.693 6.633 9.883 13.03 19.193 16.572 25.532 1.199 2.151 2.363 8.239-1.553 12.646-3.381 3.798-6.364 4.73-8.165 7.504-1.235 1.912-2.646 6.184-.325 11.096 2.776 5.867 6.162 10.685 13.592 18.234 7.547 7.421 12.364 10.804 18.242 13.581 1.918.905 3.742 1.241 5.363 1.241 2.532 0 4.574-.816 5.735-1.566 2.776-1.799 3.71-4.78 7.511-8.161 2.292-2.033 5.034-2.696 7.443-2.696 2.231 0 4.177.57 5.207 1.148 6.342 3.536 15.657 9.931 25.549 16.558 6.938 4.649 4.408 11.913 3.431 14.196-.982 2.284-6.004 9.841-16.805 15.491-2.972 1.553-6.893 2.476-11.648 2.476-14.968 0-38.155-9.16-65.66-36.651-36.237-36.217-40.635-64.946-34.188-77.26 5.651-10.798 13.213-15.818 15.5-16.795 1.074-.462 3.25-1.267 5.739-1.267zm0-10.513c-4.111 0-7.658 1.158-9.908 2.13-4.45 1.896-13.862 8.598-20.651 21.572-8.484 16.206-4.132 49.387 36.071 89.566 34.585 34.568 60.642 39.731 73.097 39.731 6.301 0 11.86-1.237 16.522-3.674 12.956-6.777 19.673-16.176 21.598-20.661 4.489-10.497 1.645-21.118-7.239-27.075-1.525-1.02-3.036-2.035-4.522-3.034-8.235-5.536-16.013-10.766-21.758-13.972-2.808-1.57-6.577-2.477-10.331-2.479-5.495 0-10.484 1.848-14.427 5.348-2.618 2.327-4.251 4.482-5.442 6.054-.246.325-.552.73-.788 1.02h-.033c-.247 0-.54-.078-.87-.234-4.366-2.062-8.274-4.609-15.298-11.51-6.908-7.024-9.456-10.928-11.519-15.292-.191-.403-.24-.699-.237-.9.29-.235.698-.543 1.025-.79 1.574-1.191 3.729-2.82 6.053-5.43 6.654-7.492 6.45-18.339 2.884-24.745-3.234-5.787-8.505-13.615-14.088-21.903-.968-1.439-1.953-2.899-2.942-4.374C70.824 26.82 64.717 23.5 57.671 23.5z" fill="#4854C7" data-color="1">
              </path>
            </g>
          </svg>
        </div>
        <p class="text-contact">
          <span>{{ contactUsData.contactUsPhone }}</span>
        </p>
      </div>
    </div>
    <div id="container-contact-form">
      <div class="row row-contact-form-contact-page">
        <div class="col-12 col-sm-6 col-contact-form-contact-page" id="container-first-name-contact-form">
          <span class="your-first-name">
            <input
              type="text"
              size="40"
              class="input-contact-form-contact-page"
              id="first-name-contact-form"
              placeholder="First Name"
              v-model="emailData.firstName"
            />
          </span>
        </div>
        <div class="col-12 col-sm-6 col-contact-form-contact-page" id="container-second-name-contact-form">
          <span class="your-second-name">
            <input
              type="text"
              size="40"
              class="input-contact-form-contact-page"
              id="second-name-contact-form"
              placeholder="Last Name"
              v-model="emailData.lastName"
            />
          </span>
        </div>
      </div>
      <div class="row row-contact-form-contact-page">
        <div class="col-12 col-sm-6 col-contact-form-contact-page" id="container-email-contact-form">
          <span class="your-email">
            <input
              type="email"
              class="input-contact-form-contact-page"
              id="email-contact-form"
              placeholder="Email"
              v-model="emailData.email"
            />
          </span>
        </div>
        <div class="col-12 col-sm-6 col-contact-form-contact-page" id="container-phone-contact-form">
          <span class="your-phone">
            <input
              type="tel"
              class="input-contact-form-contact-page"
              id="phone-contact-form"
              placeholder="Phone"
              v-model="emailData.phone"
            >
          </span>
        </div>
      </div>
      <div class="row row-contact-form-contact-page  auto-height" id="row-message-contact-form">
        <div class="col-12 col-contact-form-contact-page" id="container-message-contact-form">
          <textarea
            name="your-message"
            cols="40"
            rows="10"
            class="input-contact-form-contact-page"
            id="message-contact-form"
            aria-invalid="false"
            placeholder="Type your message here ..."
            v-model="emailData.message"
          />
        </div>
      </div>
      <div class="row row-contact-form-contact-page auto-height" id="row-button-send-form">
          <input
            type="submit"
            value="Submit"
            class="button-section btn button-confirm"
            @click="sendMail"
          />

      </div>
    </div>
  </section>
</template>

<script>

import { mapState } from 'vuex';


export default {
  name: "contactUs",
  data(){
    return{
      emailData: {
        firstName: '',
        secondName: '',
        email: '',
        phone: '',
        message: ''
      },
      reCaptchaToken: 'no token',
    }
  },
  computed : {
    ...mapState({
      infoCompany: state => state.settingsAndCustomize.siteCustomizationData.headerFooter,
      siteSittingsData: state => state.settingsAndCustomize.donorPortalSettings,
      contactUsData: state => state.settingsAndCustomize.siteCustomizationData.contactUsPage,
    })
  },
  mounted() {
    if (
        this.siteSittingsData.captchaSettings.recaptcha.enable === "1" &&
        this.siteSittingsData.captchaSettings.recaptcha.siteKey !== ''
    ) {
      const list = document.querySelectorAll('.input-contact-form-contact-page')
      list.forEach(el => {
        el.addEventListener("focus", () => {
          document.querySelector('.grecaptcha-badge').style.visibility = "visible"
        })
      })
      list.forEach(el => {
        el.addEventListener("blur", () => {
          document.querySelector('.grecaptcha-badge').style.visibility = "hidden"
        })
      })
    }
  },
  methods: {
    async sendMail(){
      let thisCu = this
      if (
          this.siteSittingsData.captchaSettings.recaptcha.enable === "1" &&
          this.siteSittingsData.captchaSettings.recaptcha.siteKey !== ''
      ) {
        await this.$recaptcha("login").then((token) => {
          if (token) {
            thisCu.reCaptchaToken = token
          }
        })
      }

      this.$root.$emit("showSpinner")
      const bodyMessage = ' First Name: ' + this.emailData.firstName + '\n'
          + ' Last Name: ' + this.emailData.lastName  + '\n'
          + ' Email: ' + this.emailData.email + '\n'
          + ' Phone: ' + this.emailData.phone + '\n'
          + ' Message: ' + this.emailData.message

      const dataEmail = {
        action: 'sendEmail',
        sendSubject: "Contact Form Message",
        sendDescription: bodyMessage,
        sendTo: this.contactUsData.contactUsMailTo,
      }
      if (this.reCaptchaToken !== 'no token') {
        dataEmail.reCaptchaToken = this.reCaptchaToken
      }

      let sendEmail = await this.$store.dispatch('communication/SET_sendEmail', dataEmail)

      this.$root.$emit("hideSpinner")

      if(sendEmail?.data?.result){
        this.$root.$emit('messageBox',
          {
            timeShow: 2000,
            typeColor: "success",
            textMessage: "Your letter sent.",
          })
      } else {
        this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: "Your letter not sent.",
        })
        console.log('ERROR sent Email. Message = ', sendEmail?.data?.message)
      }
    }
  }
}
</script>

<style scoped>
  .contact-pointer g path {
    fill: var(--BasicFontColor);
  }
  .block-address {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .container-icon {
    margin-right: 30px;
  }
  .contact-pointer {
    width: 43px;
    height: 59px;
  }
  .row-contact-form-contact-page {
    margin: 0;
    width: 50%;
    height: 50px;
  }
  .col-contact-form-contact-page {
    margin: 0;
    padding: 0;
    border: 1px solid var(--BasicFontColor);
    height: 100%;
  }
  .input-contact-form-contact-page {
    width: 100%;
    height: 100%;
    border: none;
    padding: 5px 10px;
  }
  .button-confirm{
    margin: 30px 0;
  }
  .auto-height{
   height: auto;
  }
  #row-button-send-form .button-confirm{
    margin-right: 0;
    margin-left: auto;
  }
  .text-contact {
    font-size: 25px;
    color: inherit;
    display: grid;
    white-space: pre-line;
    margin-bottom: 0;
  }
  #message-contact-form{
    margin-bottom: -6px;
  }
</style>
